import { PALETTE, BG_PALETTE } from "../lib/theme";
import type { Section5Idea } from "../lib/types";

interface Props {
  idees: Section5Idea[];
}

const RC = [PALETTE[4], PALETTE[1], PALETTE[0]];
const RB = [BG_PALETTE[4], BG_PALETTE[1], BG_PALETTE[0]];
const MEDALS = ["🥇", "🥈", "🥉"];
const LABELS = ["1ère idée", "2ème idée", "3ème idée"];

export function Podium({ idees }: Props) {
  if (!idees || idees.length < 3) return null;

  return (
    <div className="mt-5">
      <div
        className="mb-3 text-center text-[10px] font-bold uppercase tracking-widest"
        style={{ color: PALETTE[4] }}
      >
        Podium des meilleures idées
      </div>
      {idees.slice(0, 3).map((idea, i) => (
        <div
          key={`podium-${i}`}
          className="mb-2 flex items-center gap-3 rounded-xl px-3.5 py-3"
          style={{
            background: RB[i],
            border: `1.5px solid ${RC[i]}22`,
          }}
        >
          <div className="shrink-0 text-3xl" aria-hidden="true">
            {MEDALS[i]}
          </div>
          <div className="min-w-0 flex-1">
            <div
              className="mb-0.5 text-[10px] font-bold uppercase tracking-wide"
              style={{ color: RC[i] }}
            >
              {LABELS[i]}
            </div>
            <div className="text-base font-bold leading-tight text-slate-900">
              {idea.activite}
            </div>
            <div className="mt-1 text-xs text-slate-500">
              Surface moy. : {idea.surfaceMoyenne}
            </div>
          </div>
          <div className="shrink-0 text-center">
            <div
              className="text-2xl font-extrabold leading-none"
              style={{ color: RC[i] }}
            >
              {idea.score}
            </div>
            <div className="text-[10px] text-slate-400">/100</div>
          </div>
        </div>
      ))}
    </div>
  );
}
